import React, { memo } from "react";
import { useSelector } from "react-redux";
import { DSelect, passParamsThrough } from "../../../../validation/HForm";
import { listRoles, viewDocument } from "../../../../helpers/data-constants";
import useEmployees from "./use-emploee.hook";

import "./toFormRegisterModal.scss";

const RegisterModalDetails = memo((props) => {
  const { userInfo } = useSelector(({ user }) => user);
  const { employeeOptions, handleGetEmployee, usersLoading, cashboxesLeader } = useEmployees(props.selectedSendApplierId?.value);
  const isAccessRole =
    userInfo?.roles.includes(listRoles.GOODS_SPECIALIST) ||
    userInfo?.roles.includes(listRoles.ADMIN);
  const isViewPurities = props.view === viewDocument.isRegister;

  const defaultOptions = isAccessRole
    ? {
        label: `${userInfo.lastName} ${userInfo.firstName} ${userInfo.middleName}`,
        value: userInfo.id,
      }
    : { label: "", value: "" };

  const fields = [
    {
      id: "sendApplierId",
      label: "Отпуск разрешил",
      defaultValue: { label: "", value: "" },
      disabled: false,
      isShow: isViewPurities
    },
    {
      id: "senderId",
      label: "Сдал грузоотправитель",
      defaultValue: defaultOptions,
      disabled: true,
    },
    {
      id: "deliverReceptionistId",
      label: "Товар к доставке принял",
      isShow: isViewPurities,
    },
    { id: "accepterId", label: "Принял грузополучатель" },
  ];

  return passParamsThrough(
    fields.map(({ id, label, defaultValue, disabled, isShow }) => {
      if (isShow === false) return null;

      return (
        <div className="form-element" key={id}>
          <label className="form-element-label" htmlFor={id}>
            {label}
          </label>
          <div className="form-element-data combobox-lg fullwidth">
            <DSelect
              h="true"
              key={`${id}-${cashboxesLeader?.id || undefined}`}
              name={id}
              inputId={id}
              defaultValue={defaultValue}
              options={employeeOptions}
              handleOptions={handleGetEmployee}
              isLoading={usersLoading}
              placeholder="Введите фамилию"
              isDisabled={disabled}
            />
          </div>
        </div>
      );
    }),
    props
  );
});

export default RegisterModalDetails;
